import { isPlainObject } from 'lodash';

/**
 * Validate that the settings structure contains all required fields (for override mode)
 *
 * @param {object} data - Parsed settings data
 * @returns {object} { isValid: boolean, errors: string[] }
 */
export default function validateSettings(data) {
  const errors = [];

  if (!isPlainObject(data)) {
    errors.push('Invalid file format: Expected an object');
    return { isValid: false, errors };
  }

  if (!data.syncInjectorSettings) {
    errors.push('Missing required field: syncInjectorSettings');
  } else if (!isPlainObject(data.syncInjectorSettings)) {
    errors.push('Invalid syncInjectorSettings: Expected an object');
  }

  if (!data.integrations) {
    errors.push('Missing required field: integrations');
  } else if (!Array.isArray(data.integrations)) {
    errors.push('Invalid integrations: Expected an array');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}
